<template lang="pug">
  .container.container_mobile
    .loader(v-if="!ready")
    .grid.grid_h-center.grid_v-margins(v-else)
      .grid__col.grid__col_xl-20
        .block.block_wide
          .block__item.block__intro
            .block__intro-item.block__intro-item_md
              .grid.grid_v-margins
                .grid__col.grid__col_stretch
                  h2 {{ activeView.title }}
                .grid__col.grid__col_md-auto(v-if="showViewSwitch")
                  .buttons-group.buttons-group_solid
                    button.button.button_sm(
                      v-for="option in viewOptions"
                      :key="option.id"
                      :class="{'buttons-group__active button_primary-bordered': view === option.id, 'button_secondary': view !== option.id}"
                      @click="changeView(option.id)"
                    )
                      span.button__text {{ option.name }}
            div(v-show="view === 2")
              section.empty-state(v-show="!externalChampsList && !external.loading")
                .section__group.mt-0
                  .section__item Нет чемпионатов
              .loader(
                v-if="!externalChampsList"
                v-show="external.loading"
              )
              div(v-else)
                .block__intro-item.block__intro-item_md(
                  v-show="external.seasons.length > 1"
                )
                  .filters
                    .filters__container
                      .filters__item
                        .filter
                          .filter__label Год:
                          .filter__value
                            Select(
                              v-model="external.season"
                              :value="external.season"
                              :options="external.seasons"
                              :searchable="false"
                              class="color-primary"
                              cls="multiselect_dropdown-auto"
                              type="simple"
                              size="md"
                              @input="onFiltersChange"
                            )
                .block__intro-item.block__intro-item_md
                  .empty-state(v-show="!externalChampsList.length")
                    .section__group.mt-0
                      .section__item Нет результатов
                  .grid.grid_gutters-sm.grid_v-margins
                    .grid__col.grid__col_sm-12.grid__col_lg-24(
                      v-for="item in externalChampsList"
                    )
                      ChampCard(
                        :clubId="club.id"
                        :bordered="true"
                        :champ="item"
                      )
                InfiniteLoading(
                  v-if="external.useLoader"
                  :identifier="external.infiniteId"
                  @infinite="infiniteLoader"
                )
                  .loader(slot="spinner")
                  div(slot="no-more")
                  div(slot="no-results")
            div(v-show="view === 1")
              section.empty-state(v-show="!internalChampsList && !internal.loading")
                .section__group.mt-0
                  .section__item
                    img(:src="$getTenantImg('noChamps')" alt="")
                  .section__item
                    .text-lg: b Создайте первый чемпионат
                    .mt-8 Повысьте интерес к&nbsp;клубу за&nbsp;счёт внутриклубных поэтапных чемпионатов. Настройте номинации основанные на&nbsp;тренировках участников клуба.
                .section__group
                  router-link.button.button_lg.button_primary(
                    :to="{ name: 'CreateChamp', params: { id: $route.params.id } }"
                  )
                    span.button__text Создать чемпионат
              .loader(
                v-if="!internalChampsList"
                v-show="internal.loading"
              )
              div(v-else)
                .block__intro-item.block__intro-item_md(v-show="internal.seasons.length > 1")
                  .filters
                    .filters__container
                      .filters__item
                        .filter
                          .filter__label Год:
                          .filter__value
                            Select(
                              v-model="internal.season"
                              :value="internal.season"
                              :options="internal.seasons"
                              :searchable="false"
                              class="color-primary"
                              cls="multiselect_dropdown-auto"
                              type="simple"
                              size="md"
                              @input="onFiltersChange"
                            )
                .block__intro-item.block__intro-item_md
                  .empty-state(v-show="!internalChampsList.length")
                    .section__group.mt-0
                      .section__item Нет результатов
                  .grid.grid_gutters-sm.grid_v-margins
                    .grid__col.grid__col_sm-12.grid__col_lg-24(
                      v-for="item in internalChampsList"
                    )
                      ChampCard(
                        :clubId="club.id"
                        :bordered="true"
                        :internal="true"
                        :champ="item"
                      )
                InfiniteLoading(
                  v-if="internal.useLoader"
                  :identifier="internal.infiniteId"
                  @infinite="infiniteLoader"
                )
                  .loader(slot="spinner")
                  div(slot="no-more")
                  div(slot="no-results")
</template>

<script>
import Select from '@/components/Select'
import ChampCard from '@/components/ChampCard'
import { find, map } from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'ClubChamps',
  components: {
    Select,
    ChampCard,
    InfiniteLoading
  },
  props: {
    club: Object,
    clubId: String
  },
  data () {
    return {
      ready: false,
      internal: {
        season: null,
        seasons: [],
        items: [],
        loading: true,
        page: 1,
        pageSize: 6,
        useLoader: false,
        infiniteId: +new Date()
      },
      external: {
        season: null,
        seasons: [],
        items: [],
        loading: true,
        page: 1,
        pageSize: 4,
        useLoader: false,
        infiniteId: +new Date()
      },
      view: 1,
      viewOptions: [
        {
          id: 1,
          name: 'Внутри клуба',
          title: 'Внутриклубные чемпионаты',
          type: 'internal',
          list: 'internalChampsList'
        },
        {
          id: 2,
          name: 'Между клубами',
          title: 'Межклубные чемпионаты',
          type: 'external',
          list: 'externalChampsList'
        }
      ]
    }
  },
  computed: {
    ...mapState('champs', [
      'internalChamps',
      'externalChamps'
    ]),
    ...mapState('club', [
      'clubStartsInternalCount',
      'clubStartsExternalCount',
      'clubStartsItems',
      'clubStartsCount'
    ]),
    activeView () {
      return find(this.viewOptions, o => o.id === this.view)
    },
    seasonsLoaded () {
      return this.internalChamps.seasons && this.externalChamps.seasons
    },
    internalChampsList () {
      return this.internalChamps.items
    },
    externalChampsList () {
      return this.externalChamps.items
    },
    infoLoaded () {
      return !!(this.club && this.clubStartsItems)
    },
    isManager () {
      return this.club && this.club.isManager
    },
    showViewSwitch () {
      return (this.clubStartsInternalCount && this.clubStartsExternalCount) ||
        (this.isManager && this.clubStartsExternalCount)
    }
  },
  methods: {
    ...mapActions('champs', [
      'getClubSeasons',
      'getChamps'
    ]),
    ...mapMutations('champs', [
      'setChampsLoadedStatus'
    ]),
    changeView (view) {
      if (this.view === view) {
        return
      }
      this.view = view
      this.onLoadItems()
    },
    onFiltersChange () {
      const type = this.activeView.type

      this[type + 'Champs'].items = null
      this.setChampsLoadedStatus({
        type: type,
        status: false
      })
      this.onLoadItems()
    },
    setSeasons () {
      const currentYear = new Date().getFullYear()

      const extOptions = this.external.seasons = map(this.externalChamps.seasons, (o) => {
        return {
          id: o,
          name: o
        }
      })

      if (extOptions.length) {
        let extSeason = this.externalChamps.season
        extSeason = this.externalChamps.seasons.indexOf(extSeason)
          ? extSeason
          : null

        if (!extSeason && this.externalChamps.seasons.indexOf(currentYear)) {
          extSeason = currentYear
        }

        this.external.season = extSeason || extOptions[0].id
      }

      const intOptions = this.internal.seasons = map(this.internalChamps.seasons, (o) => {
        return {
          id: o,
          name: o
        }
      })

      if (intOptions.length) {
        let intSeason = this.internalChamps.season
        intSeason = this.externalChamps.seasons.indexOf(intSeason)
          ? intSeason
          : null

        if (!intSeason && this.internalChamps.seasons.indexOf(currentYear)) {
          intSeason = currentYear
        }

        this.internal.season = intSeason || intOptions[0].id
      }

      this.onLoadItems()
    },
    infiniteLoader ($state) {
      const type = this.activeView.type
      this[type].infiniteState = $state
      this.loadItems()
    },
    onLoadItems () {
      const list = this[this.activeView.list] || []
      const champs = this[this.activeView.type]
      const seasons = champs.seasons

      if (!seasons.length) {
        champs.loading = false
        return
      }

      if (list.length) {
        champs.useLoader = true
        return
      }
      this.loadItems()
    },
    loadItems () {
      const view = this.activeView
      const champs = this[view.type]
      const list = this[view.list] || []
      const infiniteState = champs.infiniteState

      if (this[view.type + 'Champs'].loaded) {
        if (infiniteState) {
          infiniteState.loaded()
          infiniteState.complete()
        }
        return
      }

      champs.loading = true
      champs.page = Math.floor(list.length / champs.pageSize) + 1

      this.getChamps({
        clubId: this.club.id,
        championshipsType: this.view,
        onlyOneId: null,
        seasonYear: champs.season,
        searchString: null,
        onlyActive: false,
        showDrafts: false,
        skip: list.length,
        take: champs.pageSize
      })
        .then(() => {
          champs.loading = false
          const list = this[view.list] || []

          if (list.length === 0) {
            infiniteState && infiniteState.complete()
            this.setChampsLoadedStatus({
              type: this.activeView.type,
              status: true
            })
            return
          }

          infiniteState && infiniteState.loaded()

          if (list.length - champs.page * champs.pageSize < 0) {
            infiniteState && infiniteState.complete()
            this.setChampsLoadedStatus({
              type: this.activeView.type,
              status: true
            })
          } else {
            champs.useLoader = true
          }
        })
        .catch(response => {
          if (response.message !== 'canceled') {
            infiniteState && infiniteState.complete()
            champs.loading = false
          }
        })
    }
  },
  watch: {
    infoLoaded: {
      handler (val) {
        if (!val) {
          return
        }
        if (this.clubStartsCount < 1) {
          if (!this.isManager) {
            this.$router.replace({
              name: 'Club',
              params: {
                id: this.$route.params.id || this.$getTenantIdClub()
              }
            })
          } else {
            this.internal.loading = false
            this.external.loading = false
          }
          this.ready = true
          return
        }
        const v = +this.$route.query.type
        if (v === 1 || v === 2) {
          this.view = v
        }
        if (this.view === 1 && !this.clubStartsInternalCount && this.clubStartsExternalCount && !this.isManager) {
          this.view = 2
        }
        if (this.view === 2 && !this.clubStartsExternalCount) {
          this.view = 1
        }
        this.getClubSeasons({ clubId: this.club.id })
      },
      immediate: true
    },
    seasonsLoaded: {
      handler (val) {
        if (!val) {
          return
        }
        this.setSeasons()
        this.ready = true
      },
      immediate: true
    }
  }
}
</script>
